export default "__VITE_ASSET__8df003df__"